// These are for populating prompt content with appropriate adjectives given a patient's
// self described strengths on the goal page.
export default function getQualities(fromStrengths) {
  const qualities = []

  for (let s of fromStrengths) {
    switch (s) {
      case 'SPORTS':
        qualities.push('PERSISTENT', 'DISCIPLINED')
        break
      case 'MUSIC':
        qualities.push('PERSISTENT', 'DISCIPLINED')
        break
      case 'WRITING':
        qualities.push('THOUGHTFUL', 'CREATIVE')
        break
      case 'READING':
        qualities.push('INTELLIGENT', 'CONTEMPLATIVE')
        break
      case 'MATH':
        qualities.push('ANALYTICAL', 'RATIONAL')
        break
      case 'SCIENCE':
        qualities.push('ANALYTICAL', 'RATIONAL')
        break
      case 'LANGUAGES':
        qualities.push('CREATIVE', 'INTELLIGENT')
        break
      case 'THEATER':
        qualities.push('CREATIVE', 'PRACTICED')
        break
      case 'SINGING':
        qualities.push('CONFIDENT', 'PRACTICED')
        break
      case 'ART':
        qualities.push('CREATIVE', 'RESOURCEFUL')
        break
      case 'GAMES':
        qualities.push('PATIENT', 'PERCEPTIVE')
        break
      case 'COOKING':
        qualities.push('PATIENT', 'CONSISTENT')
        break
      case 'MY_JOB':
        qualities.push('DISCIPLINED', 'RESPONSIBLE')
        break
      case 'MONEY_MANAGEMENT':
        qualities.push('TIMELY', 'ECONOMICAL')
        break
      case 'FIXING_THINGS':
        qualities.push('ANALYTICAL', 'RESOURCEFUL')
        break
      case 'COMMUNICATING_WITH_OTHERS':
        qualities.push('PATIENT', 'PERCEPTIVE')
        break
      case 'CARE_OF_OTHERS':
        qualities.push('PERCEPTIVE', 'RESPONSIBLE')
        break
      case 'RELIGIOUS_OBSERVATION':
        qualities.push('DISCIPLINED', 'DEVOTED')
        break
      case 'HOUSE_WORK':
        qualities.push('OBSERVANT', 'ORDERLY')
        break
      case 'FASHION':
        qualities.push('CREATIVE', 'OBSERVANT')
        break
      case 'DRIVING':
        qualities.push('ANALYTICAL', 'PERCEPTIVE')
        break
      case 'SHOPPING':
        qualities.push('PERCEPTIVE', 'ECONOMICAL')
        break
      default:
        throw new Error("something is wrong with qualities generator: strength not found")
    }
  }

  return qualities.filter((v, i) => qualities.indexOf(v) === i)
}



// WEBPACK FOOTER //
// ./src/utils/getQualities.js